const mFeedSectionContentFooter = {
  mFeedSectionContentFooter: {
    title: 'Todos los derechos reservados'
  }
}

export default mFeedSectionContentFooter
